import RequestModuleTable from '@/app/request-module'
import { ability } from '@/casl/ability'
import TableSkeleton from '@/components/table-skeleton'
import { getFirstAccessibleRoute } from '@/constants/Auth'
import { requestModuleByCompanyQueryOptions } from '@/hooks/useRequestModuleQuery'
import LocalStorage from '@/utilities/LocalStorage'
import { createFileRoute, redirect } from '@tanstack/react-router'

const RouteComponent = () => {
  return <RequestModuleTable />
}

export const Route = createFileRoute('/_auth/_withProject/request-module')({
  beforeLoad: ({ context }) => {
    if (ability && context.auth.user && !ability.can('read', 'Talep')) {
      // toast.error("Bu sayfayı görüntüleme izniniz yok.")
      const permissions = context.auth.user.permissions || []
      const redirectPath = getFirstAccessibleRoute(permissions)
      throw redirect({
        to: redirectPath,
      })
    }
  },
  loader: async ({ context }) => {
    const { queryClient } = context

    const companyId = LocalStorage.selectedCompany()?.id

    await queryClient.prefetchQuery(requestModuleByCompanyQueryOptions(companyId))
    return {}
  },
  pendingComponent: TableSkeleton,
  component: RouteComponent,
})


